module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/awesome-typescript-loader/dist/entry.js?silent=true!./costbook-grid.ts"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./ClientApp/components/costbook-grid/costbook-grid.ts
// module id = 95
// module chunks = 53